import { render, staticRenderFns } from "./EditOccurrences.vue?vue&type=template&id=07c0b762&scoped=true&"
import script from "./EditOccurrences.vue?vue&type=script&lang=js&"
export * from "./EditOccurrences.vue?vue&type=script&lang=js&"
import style0 from "./EditOccurrences.vue?vue&type=style&index=0&id=07c0b762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c0b762",
  null
  
)

export default component.exports